import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		redirect: 'negative',
		children: [{
			path: 'negative',
			component: () => import('@/views/negative'),
			name: 'negative',
			meta: {
				isAuth: true
			}
		}, {
			path: 'selected',
			component: () => import('@/views/selected'),
			name: 'selected',
			meta: { isAuth: true }
		}, {
			path: 'product',
			component: () => import('@/views/product'),
			name: 'product',
			meta: { isAuth: true }
		}]

	},
	{
		path: '/entry',
		name: 'entry',
		component: () => import('../views/entry.vue'),
		meta: {
			isAuth: false
		}
	}, 
	{
		path: '/404',
		name: '404',
		component: () => import('../views/404.vue'),
		meta: {
			isAuth: false
		}
	}, 
	{
		path: '*',
		redirect:'/'
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})




export default router
